// extracted by mini-css-extract-plugin
export default {"map":"CaliforniaMade_map__bS2Qt","textContainer":"CaliforniaMade_textContainer__IWBAn"};